// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"398":"9f0b8e2e","787":"ab4f2361"}[chunkId] + ".chunk.js";
};